import { Swiper, SwiperSlide } from "swiper/react";
import { useHistory } from "react-router-dom";
import { NewsResponse } from "../../../../api/news";
import { CardItemWrapper, NewsWrapper } from "../style/hotNews";

const HotNews = ({ list }: { list: NewsResponse[] }) => {
  const history = useHistory();

  if (list.length === 0) {
    return null;
  }

  return (
    <NewsWrapper>
      <Swiper
        slidesPerView={"auto"}
        centeredSlides={false}
        spaceBetween={10}
        className="mySwiper"
      >
        {list.map((item) => {
          return (
            <SwiperSlide key={item.id}>
              <CardItemWrapper
                onClick={() =>
                  history.push(`/news-detail/${item.id}`, { fromNews: true })
                }
              >
                <div
                  className="thumbnail"
                  style={{
                    backgroundImage: `url('${item.mainImageKey}')`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                  }}
                />
                <div className="info">
                  <div className="title-row">
                    <div className="today">오늘의 뉴스</div>
                    <div className="title">{item.title}</div>
                  </div>
                </div>
              </CardItemWrapper>
            </SwiperSlide>
          );
        })}
      </Swiper>
    </NewsWrapper>
  );
};

export default HotNews;
